import type { TransformParamTypes } from '@/types/generics'
import { generateVideoSrc, convertVideoToImageUrl } from '../media-transformer'

export function alpineVideo({
  width,
  transforms,
}: {
  width: number
  transforms: TransformParamTypes
}) {
  return {
    ':url'() {
      if (!this.url) {
        return
      }

      const src = generateVideoSrc(this.url, { q: '70', ...transforms }, width)
      const srcWebm = src.replaceAll(/\.(mp4)/g, '.webm')

      const posterSrc = generateVideoSrc(
        convertVideoToImageUrl(this.url),
        { q: 'auto', so: 'auto', ...transforms },
        width * 2,
      )

      this.src = src
      this.srcWebm = srcWebm
      this.posterSrc = posterSrc
    },
  } as any
}
